import { TextField, styled } from '@mui/material';
import { PinnacleTextFieldProps } from './PinnacleTextField.types';

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'invalidEmail'
})<PinnacleTextFieldProps>(({ theme, invalidEmail, variant }) => ({
  width: '100%',

  '& .MuiInputBase-input': {
    fontSize: '14px',
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#000',
  },
  '& .MuiInputLabel-root.Mui-error': {
    color: '#ff4d4d',
  },
  '& .MuiFormHelperText-root': {
    backgroundColor: 'transparent',
    color: '#000',
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: '#ff4d4d',
  },
  ...(invalidEmail && {
    '& .MuiInputBase-root': {
      borderColor: '#ff4d4d',
    },
  }),
  ...(variant === 'filled' && {
    '& .MuiInputBase-root': {
      backgroundColor: 'transparent',
      '& input': {
        color: '#000',
      },
    },
  }),

  'label:not([data-shrink=true])+.MuiInputBase-formControl': {
    'input::-webkit-input-placeholder': {
      opacity: '0 !important',
    },
  },
}));

export default StyledTextField;
